import React from 'react'
import { Drawer } from 'antd'
import { useFFEStore } from '../../store/ffeStore'
import { MaterialForm } from './MaterialForm'
import { AccessoriesForm } from './AccessoriesForm'

interface Props {
  materialId: string | null
  accessories?: boolean
  onClose: () => void
}

export const MaterialEditDrawer: React.FC<Props> = ({
  materialId,
  accessories,
  onClose
}) => {
  const material = useFFEStore((state) =>
    materialId
      ? state.document.materials.find((m) => m.id === materialId)
      : null
  )

  const entity = accessories ? 'Accessory' : 'Material'
  const title = material ? `Edit ${entity}` : `Add ${entity}`

  return (
    <Drawer
      title={title}
      placement="right"
      width={600}
      open={!!materialId}
      onClose={onClose}
    >
      {material && accessories && (
        <AccessoriesForm initialValues={material} onSuccess={onClose} />
      )}
      {material && !accessories && (
        <MaterialForm initialValues={material} onSuccess={onClose} />
      )}
    </Drawer>
  )
}
